/* tslint:disable */
/* eslint-disable */
/**
 * External EMR API
 * Clinical documents pulled from external EMRs (Net Health today) for a patient\'s external EHR record. Consumer-agnostic: concurrent review is the first consumer, but nothing here is re-auth specific. Routes are lead-scoped because the pull needs the lead\'s facility to resolve the Net Health consumer site; the documents themselves belong to the external EHR patient.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ExternalEmrType = {
    NetHealth: 'NET_HEALTH'
} as const;
export type ExternalEmrType = typeof ExternalEmrType[keyof typeof ExternalEmrType];


export function ExternalEmrTypeFromJSON(json: any): ExternalEmrType {
    return ExternalEmrTypeFromJSONTyped(json, false);
}

export function ExternalEmrTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExternalEmrType {
    return json as ExternalEmrType;
}

export function ExternalEmrTypeToJSON(value?: ExternalEmrType | null): any {
    return value as any;
}

